export default interface ICadPessoas {
  id: number;
  access_key: string;
  id_license: string;
  ativo: boolean;
  codigo: number;
  tipo_pessoa: string;
  vinculo_pessoa: string;
  nome: string;
  nome_fantasia: string;
  inscricao_federal: string;
  inscricao_estatual: string;
  inscricao_municipal: string;
  endereco: string;
  telefone: string;
  email: string;
  contato: string;
  obs: string;
  inf1: string;
  inf2: string;
  inf3: string;
  inf4: string;
  inf5: string;
  acao: string;
  created_at: Date | undefined;
  updated_at: Date | undefined;
}

export const emptyCadPessoas: ICadPessoas = {
  id: 0,
  access_key: '',
  id_license: '',
  ativo: true,
  codigo: 0,
  tipo_pessoa: '1-Jurídica',
  vinculo_pessoa: '1-Cliente',
  nome: '',
  nome_fantasia: '',
  inscricao_federal: '',
  inscricao_estatual: '',
  inscricao_municipal: '',
  endereco: '',
  telefone: '',
  email: '',
  contato: '',
  obs: '',
  inf1: '',
  inf2: '',
  inf3: '',
  inf4: '',
  inf5: '',
  acao: '',
  created_at: undefined,
  updated_at: undefined,
};
